import { render, staticRenderFns } from "./RemainingLeavesReports.vue?vue&type=template&id=61e92be3"
import script from "./RemainingLeavesReports.vue?vue&type=script&lang=js"
export * from "./RemainingLeavesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports